module.exports = __webpack_public_path__ + "img/slh-left-xian.6d686426.png";